<template>
  <v-progress-linear
    color="deno"
    height="8"
    indeterminate
    striped
    id="app-progress"
    style="position: absolute; top: 100; left: 0"
  >
  </v-progress-linear>
</template>

<script>
export default {};
</script>

<style>
#app-progress {
  position: fixed;
  top: 1000;
  left: 0;
}
</style>
